import { usePermissionsSelector } from "front";

export const useGroupAdministration = () => {
  const { userPerm } = usePermissionsSelector("userPerm");
  return { isLoading: !userPerm.id };
};
